export default {
  computed: {
    isPublisher() {
      return this.$auth.check('publisher');
    },
    isSudoer() {
      return this.$auth.user?.isSudoFromAdmin;
    },
    hasDeveloperAPIAccess() {
      return this.$auth.check('developersApi');
    },
    hasOAuth() {
      return this.isPublisher || this.hasDeveloperAPIAccess;
    },
  },
  methods: {
    hasChangeAppInfo(appId) {
      if (this.isPublisher) {
        return true;
      }

      return this.$auth.checkAppPermission('changeAppInfo', appId);
    },

    hasPublish(appId) {
      if (this.isPublisher) {
        return true;
      }

      return this.$auth.checkAppPermission('publish', appId);
    },

    hasStatistics(appId) {
      if (this.isSudoer) return true;
      return this.$auth.checkAppPermission('statistics', appId);
    },

    hasSupport(appId) {
      if (this.isPublisher) {
        return true;
      }

      return this.$auth.checkAppPermission('support', appId);
    },

    hasDevelopment(appId) {
      if (this.isPublisher) {
        return true;
      }

      return this.$auth.checkAppPermission('development', appId);
    },

    hasAdvertisement(appId) {
      if (this.isPublisher) {
        return true;
      }

      return this.$auth.checkAppPermission('advertisement', appId);
    },

    hasFinance(appId) {
      if (this.isPublisher) {
        return true;
      }

      return this.$auth.checkAppPermission('viewFinance', appId);
    },
  },
};
